import { useMemo } from 'react'

import { faCheck, faSave } from '@fortawesome/pro-solid-svg-icons'

import StudentForm from './StudentForm'
import ConfirmFormFooter from '../../../Components/antd/Forms/ConfirmFormFooter'
import { isOptimistic } from '../../../utils'
import { Permissions } from './SearchStudentModalProvider'

const SingleStudentForm = ({ confirmButton, data, disabled, permission, onChange, onSubmit, onCancel }) => {
  const config = useMemo(() => {
    let formPermission
    let buttonTitle
    let buttonIcon

    if (confirmButton !== undefined) {
      buttonTitle = confirmButton?.title
      buttonIcon = confirmButton?.icon
    } else if (isOptimistic(data)) {
      formPermission = Permissions.WRITE
      buttonTitle = 'modal.ok_button.save'
      buttonIcon = faSave
    } else {
      formPermission = permission
      buttonTitle = 'modal.ok_button.confirm'
      buttonIcon = faCheck
    }

    return {
      permission: formPermission,
      buttonTitle,
      buttonIcon
    }
  }, [confirmButton, data, permission])

  return (
    <div className='mb-12 pd-16'>
      <div className='modal-inner-container'>
        <StudentForm
          data={data}
          permission={config.permission}
          onChange={onChange}
        />
      </div>

      <ConfirmFormFooter
        divider
        disabled={disabled}
        confirmTitle={config.buttonTitle}
        confirmIcon={config.buttonIcon}
        onCancel={onCancel}
        onConfirm={() => onSubmit(data)}
      />
    </div>
  )
}

export default SingleStudentForm
